// handles product brief display on different resolutions
import * as React from 'react';
import { observer } from 'mobx-react';
import { IProductBriefCollectionWrapper, ProductBriefCollection } from './ProductBriefCollection';
import { Breakpoints } from '@estee/elc-base-theme';
import { Desktop, Mobile } from '@estee/elc-layouts';

export const ProductBriefCollectionWrapper = observer(function ProductBriefCollectionWrapper(
    props: IProductBriefCollectionWrapper
) {
    return (
        <>
            <Desktop minWidth={Breakpoints.desktop}>
                {() => <ProductBriefCollection {...props} isMobile={false} />}
            </Desktop>
            <Mobile maxWidth={Breakpoints.desktop - 1}>
                {() => <ProductBriefCollection {...props} isMobile />}
            </Mobile>
        </>
    );
});
